(function () {
  /* --- Drag-to-scroll (mouse only) --- */
  var activeSlider = null;
  var startX = 0;
  var scrollLeft = 0;
  var hasMoved = false;

  document.addEventListener('mousedown', function (e) {
    var track = e.target.closest('[data-sc-track]');
    if (!track || e.target.closest('.sub-collections-slider__nav')) return;
    e.preventDefault();
    activeSlider = track;
    startX = e.clientX;
    scrollLeft = track.scrollLeft;
    hasMoved = false;
    track.style.scrollBehavior = 'auto';
  });

  document.addEventListener('mousemove', function (e) {
    if (!activeSlider) return;
    e.preventDefault();
    var walk = (e.clientX - startX) * 1.5;
    if (Math.abs(e.clientX - startX) > 5) {
      hasMoved = true;
      activeSlider.classList.add('is-dragging');
    }
    activeSlider.scrollLeft = scrollLeft - walk;
  });

  document.addEventListener('mouseup', function () {
    if (!activeSlider) return;
    activeSlider.style.scrollBehavior = 'smooth';
    activeSlider.classList.remove('is-dragging');
    activeSlider = null;
  });

  /* Block click after drag */
  document.addEventListener('click', function (e) {
    if (hasMoved && e.target.closest('[data-sc-track]')) {
      e.preventDefault();
      e.stopPropagation();
      hasMoved = false;
    }
  }, true);

  /* --- Init each slider instance --- */
  document.querySelectorAll('[data-sub-collections-slider]').forEach(function (root) {
    var track = root.querySelector('[data-sc-track]');
    var prevBtn = root.querySelector('[data-sc-prev]');
    var nextBtn = root.querySelector('[data-sc-next]');
    var progressWrapper = root.querySelector('[data-sc-progress]');
    var progressBar = root.querySelector('[data-sc-progress-bar]');

    if (!track || !prevBtn || !nextBtn) return;

    function updateProgressBar() {
      if (!progressWrapper || !progressBar) return;
      var canScroll = track.scrollWidth > track.clientWidth + 5;
      if (!canScroll) {
        progressWrapper.style.display = 'none';
        return;
      }
      progressWrapper.style.display = '';
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      var scrollRatio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var barWidth = Math.max(ratio, 0.15);
      var translateX = scrollRatio * ((1 / barWidth) - 1) * 100;
      progressBar.style.width = (barWidth * 100) + '%';
      progressBar.style.transform = 'translateX(' + translateX + '%)';
    }

    function updateNav() {
      var canScroll = track.scrollWidth > track.clientWidth + 5;
      if (!canScroll) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }
      var isAtStart = track.scrollLeft <= 5;
      var isAtEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 5;
      prevBtn.style.display = isAtStart ? 'none' : 'flex';
      nextBtn.style.display = isAtEnd ? 'none' : 'flex';
    }

    function update() {
      updateNav();
      updateProgressBar();
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
})();
